import { useMemo } from 'react';

import { UsageType } from '@client/api';

type Usage = UsageType | null;

export const useIsUsageType = (
  usageType?: Usage
) => {
  const isResidentialOrMixed = useMemo(() => {
    if (usageType == null) return false;
    const allowedUsageTypes: UsageType[] = ['Residential', 'Mixed'];
    return allowedUsageTypes.includes(usageType);
  }, [usageType])

  const isCommercialOrMixed = useMemo(() => {
    if (usageType == null) return false;
    const allowedUsageTypes: UsageType[] = ['Commercial', 'Mixed'];
    return allowedUsageTypes.includes(usageType);
  }, [usageType]);

  const isResidential = useMemo(() => {
    if (usageType == null) return false;
    return usageType === 'Residential';
  }, [usageType])

  const isCommercial = useMemo(() => {
    if (usageType == null) return false;
    return usageType === 'Commercial';
  }, [usageType])

  const isMixed = useMemo(() => {
    if (usageType == null) return false;
    return usageType === 'Mixed';
  }, [usageType])

  return { isResidentialOrMixed, isCommercialOrMixed, isResidential, isCommercial, isMixed };
};
